import type { AuthResult } from './authResponse';

/**
 * Module-level in-flight refresh so React StrictMode's mount → unmount → mount
 * cycle reuses one network call. Refresh cookies rotate on use; a second
 * concurrent /auth/refresh would replay a spent token and can revoke the session.
 *
 * Cleared on logout so a later remount cannot reuse a pre-logout success.
 */
let sessionRestorePromise: Promise<AuthResult | null> | null = null;

export function restoreSession(
  refresh: () => Promise<AuthResult | null>
): Promise<AuthResult | null> {
  if (!sessionRestorePromise) {
    sessionRestorePromise = refresh();
  }
  return sessionRestorePromise;
}

/** Drop the cached restore attempt (call on logout / failed session). */
export function resetSessionRestore(): void {
  sessionRestorePromise = null;
}

/** @internal vitest helper — clear cached bootstrap between tests */
export function __resetSessionRestoreForTests(): void {
  sessionRestorePromise = null;
}
